import i18n, { use } from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

export const InitialConfig = {
  backend: {
    loadPath: '/locales/{{lng}}.json',
  },
  debug: false,
  fallbackLng: 'es',
  interpolation: {
    escapeValue: false,
    formatSeparator: ',',
  },
  keySeparator: false,
  nsSeparator: false,
}

use(Backend).use(initReactI18next).init(InitialConfig)

export default i18n
